var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.userType == _vm.COMPANY.value ? _c('company-expo-program-list', _vm._b({}, 'company-expo-program-list', {
    tab: _vm.tab
  }, false)) : _vm.userType == _vm.PERSON.value ? _c('person-expo-program-list', _vm._b({}, 'person-expo-program-list', {
    tab: _vm.tab
  }, false)) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }